import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import WelcomeCard from "../../Components/WelcomeCard/WelcomeCard";
import {
  Box,
  Typography,
  TextField,
  MenuItem,
  Snackbar,
  Alert,
} from "@mui/material";
import Table, {
  type TableColumn,
} from "../../Components/CommonTable/CommonTable";
import { useAppDispatch, useAppSelector } from "../../../../Redux/Store/Hooks";
import {
  clearStudyMaterialAddToCartCreate,
  studyMaterialAddToCartCreate,
} from "../../../../Redux/Slices/Booklet/Tutor/StudyMaterial/StudyMaterialAddToCartCreate";
import {
  ClassYeargroupRead,
  clearClassYeargroupRead,
} from "../../../../Redux/Slices/Booklet/Tutor/ClassSelection/ClassYeargroup";
import { ClassSubjectRead } from "../../../../Redux/Slices/Booklet/Tutor/ClassSelection/ClassSubject";
import { ClassDrive_fileRead } from "../../../../Redux/Slices/Booklet/Tutor/ClassSelection/ClassDriveFile";
import {
  ClassSection,
  FileItem,
  Option,
  StudyMaterial,
} from "./IStudyMaterial";
import SearchBar from "../../Components/search/Search";
import { clearAiDriveSearch } from "../../../../Redux/Slices/Booklet/Tutor/AiSearch/AiSearch";
import { clearCentreMasterCreate } from "../../../../Redux/Slices/Booklet/Admin/CentreMaster/CentreMasterCreate";
import ReportIcon from "@mui/icons-material/Report";
import {
  ClassCenterRead,
  clearClassCenterRead,
} from "../../../../Redux/Slices/Booklet/Tutor/ClassSelection/ClassCenter";
import { ClassContextBar } from "../../Components/ClassContextBar/ClassContextBar";
import { ScheduledClass } from "../../Components/ClassContextBar/IClassContextBar";
import { StudyMaterialCartCount } from "../../../../Redux/Slices/Booklet/Tutor/StudyMaterial/StudyMaterialCartCount";
import { TutorDashboardClassesRead } from "../../../../Redux/Slices/Booklet/Tutor/Dashboard/DashboardAssignedClasses";

interface SearchAPIResponse {
  found_items: {
    id: string;
    name: string;
    mime_type: string;
    drive_link: string;
    modified_time?: string;
    subject_id: number;
  }[];
  cached: boolean;
  cache_age: string;
  total_results: number;
  query: string;
}

const formatRelativeDate = (dateString: string): string => {
  try {
    const date = new Date(dateString);
    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - date.getTime()) / 1000);
    if (diffInSeconds < 60) return "Just now";
    if (diffInSeconds < 3600) {
      const minutes = Math.floor(diffInSeconds / 60);
      return minutes === 1 ? "1 minute ago" : `${minutes} minutes ago`;
    }
    if (diffInSeconds < 86400) {
      const hours = Math.floor(diffInSeconds / 3600);
      return hours === 1 ? "1 hour ago" : `${hours} hours ago`;
    }
    if (diffInSeconds < 604800) {
      const days = Math.floor(diffInSeconds / 86400);
      return days === 1 ? "Yesterday" : `${days} days ago`;
    }
    if (diffInSeconds < 2592000) {
      const weeks = Math.floor(diffInSeconds / 604800);
      return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
    }
    if (diffInSeconds < 31536000) {
      const months = Math.floor(diffInSeconds / 2592000);
      return months === 1 ? "1 month ago" : `${months} months ago`;
    }
    const years = Math.floor(diffInSeconds / 31536000);
    return years === 1 ? "1 year ago" : `${years} years ago`;
  } catch {
    return "Unknown";
  }
};

const StudyMaterials = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const selectedData = location.state;
  const [isSearchMode, setIsSearchMode] = useState(false);
  const selectedClassid = selectedData?.id || "";
  const [lastEditedRow, setLastEditedRow] = useState<{
    id: string;
    previousQty: number;
  } | null>(null);
  console.log(selectedClassid, "selectedClassid");
  console.log(selectedData, "selectedData");

  const [username, setUsername] = useState<string>("User");
  const [isLocked, setIsLocked] = useState(false);
  const [filters, setFilters] = useState({
    center: "",
    yearOfGroup: "",
    subject: "",
    topic: "",
  });

  const [tableData, setTableData] = useState<StudyMaterial[]>([]);
  const [selectedClassId, setSelectedClassId] =
    useState<string>(selectedClassid);
  const { data: yearGroupData, isLoading: yearGroupLoading } = useAppSelector(
    (state) => state.ClassYeargroupRead
  );
  const { data: CenterData, isLoading: CenterLoading } = useAppSelector(
    (state) => state.ClassCenterRead
  );
  const { data: subjectData, isLoading: subjectLoading } = useAppSelector(
    (state) => state.ClassSubjectRead
  );
  const { data: driveFileData, isLoading: driveFileLoading } = useAppSelector(
    (state) => state.ClassDrive_fileRead
  );
  const { data: ClassesData, isLoading: ClassesLoading } = useAppSelector(
    (state) => state.TutorDashboardClassesRead
  );

  const { data: AddToCartData, isLoading: AddToCartDataLoading } =
    useAppSelector((state) => state.StudyMaterialAddToCartCreateSlice);

  const { data: SearchData, isLoading: searchDataLoading } = useAppSelector(
    (state) => state.AiDriveSearch
  ) as { data?: SearchAPIResponse; isLoading: boolean };

  const yearGroups = yearGroupData?.data ?? [];
  const Center = CenterData?.data ?? [];
  const subjects = subjectData?.data ?? [];
  const driveData = driveFileData?.data ?? [];
  console.log(CenterData, "CenterData");

  const clearAllFilters = () => {
    if (!selectedData) {
      setFilters((prev) => ({ ...prev, subject: "", topic: "" }));
    } else {
      setFilters((prev) => ({ ...prev, topic: "" }));
    }
    setTableData([]);
    dispatch(clearAiDriveSearch());
  };
  const [snackbar, setSnackbar] = useState<{
    open: boolean;
    message: string;
    severity: "success" | "error";
    key?: number;
  }>({ open: false, message: "", severity: "success" });

  const showSnackbar = (message: string, severity: "success" | "error") => {
    setSnackbar({
      open: true,
      message,
      severity,
      key: new Date().getTime(), // 👈 unique key
    });
  };

  useEffect(() => {
    const storedUsername = sessionStorage.getItem("username");
    if (storedUsername) {
      const formatted =
        storedUsername.charAt(0).toUpperCase() +
        storedUsername.slice(1).toLowerCase();
      setUsername(formatted);
    }
  }, []);

  useEffect(() => {
    dispatch(clearStudyMaterialAddToCartCreate());
    dispatch(ClassYeargroupRead());
    dispatch(ClassCenterRead());
    dispatch(TutorDashboardClassesRead());
  }, [dispatch]);

  useEffect(() => {
    dispatch(clearAiDriveSearch());
    dispatch(clearClassYeargroupRead());
    dispatch(clearClassCenterRead());
  }, [dispatch]);
  console.log(SearchData, "SearchData");

  useEffect(() => {
    if (
      (!SearchData?.found_items || SearchData.found_items.length === 0) &&
      !filters.topic
    ) {
      setTableData([]);
    }
  }, [SearchData, filters.topic]);

  useEffect(() => {
    if (filters.yearOfGroup) {
      dispatch(ClassSubjectRead({ item_id: filters.yearOfGroup }));
      if (!selectedData) {
        setFilters((prev) => ({ ...prev, topic: "" }));
      }
    }
  }, [filters.yearOfGroup, dispatch]);

  useEffect(() => {
    if (filters.subject) {
      dispatch(ClassDrive_fileRead({ item_id: filters.subject }));
      if (!selectedData) {
        setFilters((prev) => ({ ...prev, topic: "" }));
      }
    }
  }, [filters.subject, dispatch]);

  const extractAllFiles = (items: FileItem[]): FileItem[] => {
    let files: FileItem[] = [];
    for (const item of items) {
      if (item.type === "file") {
        files.push(item);
      } else if (item.children && item.children.length > 0) {
        files = files.concat(extractAllFiles(item.children));
      }
    }
    return files;
  };

  useEffect(() => {
    if (filters.topic) {
      const selectedTopic = driveData.find((t: any) => t.id === filters.topic);
      if (selectedTopic) {
        // Include top-level files in addition to children
        const topLevelFiles =
          selectedTopic.type === "file" ? [selectedTopic] : [];
        const allFiles = extractAllFiles(selectedTopic.children || []);
        const files = [...topLevelFiles, ...allFiles].map((item: FileItem) => ({
          id: item.id,
          name: item.name,
          mimeType: item.mimeType,
          webViewLink: item.webViewLink,
          modifiedTime: item.modified_time,
          lastUpdate: formatRelativeDate(item.modified_time),
          editable: true,
          subject_id: item.subject_id,
          quantity: 0,
          print: "Take Print",
          status: false,
        }));
        setTableData(files);
      } else {
        setTableData([]);
      }
    }
  }, [filters.topic, driveData]);

  const upcomingClasses: ScheduledClass[] = useMemo(() => {
    if (!ClassesData?.data) return [];
    return ClassesData.data.map((item: any) => ({
      date: item.date
        ? new Date(item.date)
            .toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "2-digit",
            })
            .replace(/\//g, "-")
        : "-",
      day: item.day || "-",
      csms_id: item.csms_id || "",
      yearLevel: item.year_group?.year_group || "-", // ← camelCase
      yearLevel_id: item.year_group?.id || "-", // ← keep as-is or convert to number
      subject_id: item.subject?.id || "-",
      center_id: item.center?.center_id || "-",
      center: item.center?.center_name || "-",
      print_request_status: item.print_request_status || "not_yet_requested",
      subject: item.subject?.name || "-",
      request_ids: item.request_ids ?? [],
    }));
  }, [ClassesData]);

  useEffect(() => {
    if (SearchData?.found_items && SearchData.found_items.length > 0) {
      const files = SearchData.found_items.map((item: any) => ({
        id: item.id,
        name: item.name,
        mimeType: item.mime_type,
        webViewLink: item.drive_link,
        modifiedTime: item.modified_time || "", // if available
        lastUpdate: formatRelativeDate(
          item.modified_time || new Date().toISOString()
        ),
        editable: true,
        quantity: 0,
        subject_id: item.subject_id,
        print: "Take Print",
        status: false,
      }));
      setTableData(files);
    } else if (!filters.topic) {
      setTableData([]);
    }
  }, [SearchData]);

  useEffect(() => {
    if (!AddToCartData) return;
    if (AddToCartData.status === true) {
      showSnackbar(AddToCartData?.message || "Added to cart", "success");
      dispatch(StudyMaterialCartCount());
    }
    if (AddToCartData.status === false) {
      showSnackbar(AddToCartData?.message || "Something went wrong", "error");

      if (lastEditedRow) {
        setTableData((prev) =>
          prev.map((item) =>
            item.id === lastEditedRow.id
              ? { ...item, quantity: lastEditedRow.previousQty }
              : item
          )
        );
      }
    }
  }, [AddToCartData]);

  const selectedClass = useMemo(() => {
    if (!selectedClassId) return "custom";
    return (
      upcomingClasses.find((cls) => cls.csms_id === selectedClassId) || null
    );
  }, [upcomingClasses, selectedClassId]);

  const searchSubjectId = useMemo(() => {
    if (typeof selectedClass !== "string" && selectedClass?.subject_id) {
      return selectedClass.subject_id.toString();
    }
    return filters.subject;
  }, [selectedClass, filters.subject]);

  // ---------- Options ----------
  const yearOptions = yearGroups.map((y: any) => ({
    id: y.id,
    label: y.yeargroup.name,
  }));
  const centerOptions = Center.map((c: any) => ({
    id: c.center_id,
    label: c.center_name,
  }));
  const subjectOptions = subjects.map((s: any) => ({
    id: s.id,
    label: s.name,
  }));
  const topicOptions = driveData.map((t: any) => ({ id: t.id, label: t.name }));
  const handleFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleQuantityChange = (
    row: StudyMaterial,
    _index: number,
    newQuantity: number
  ) => {
    if (!filters.center) {
      showSnackbar("Center is required before adding to cart", "error");
      return;
    }
    // if (!filters.subject) {
    //   showSnackbar("Subject is required before adding to cart", "error");
    //   return;
    // }
    // if (!filters.topic) {
    //   showSnackbar("Topic is required before adding to cart", "error");
    //   return;
    // }
    setLastEditedRow({
      id: row.id,
      previousQty: row.quantity,
    });

    setTableData((prev) =>
      prev.map((item) =>
        item.id === row.id
          ? { ...item, quantity: newQuantity, status: row.status }
          : item
      )
    );

    const csms_id =
      typeof selectedClass !== "string" && selectedClass
        ? selectedClass.csms_id
        : null;

    const payload = {
      cart_id: "0",
      pdf_id: row.id,
      tutor_id: 0,
      quantity: newQuantity,
      status: row.status,
      center_id: filters.center || selectedData.center_id,
      subject_id: filters.subject || row.subject_id,
      topic_id: filters.topic,
      csms_id: csms_id,
      created_on: new Date().toISOString(),
      updated_on: new Date().toISOString(),
    };

    dispatch(studyMaterialAddToCartCreate(payload));
  };

  const columns: TableColumn<StudyMaterial>[] = [
    {
      key: "name",
      title: "File Name",
      render: (value) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {String(value)}
        </Typography>
      ),
    },
    { key: "lastUpdate", title: "Last Updated", sortable: true },
    { key: "preview", title: "Preview" },
    { key: "Add to Cart", title: "Add to Cart" },
  ];

  useEffect(() => {
    if (selectedData) {
      setFilters({
        yearOfGroup: selectedData.yeargroup_id,
        center: selectedData.center_id,
        subject: selectedData.subject_id,
        topic: "",
      });
      setSelectedClassId(selectedClassid);
      setIsLocked(true);
    } else {
      setSelectedClassId("");
      setIsLocked(false);
    }
  }, [selectedData, selectedClassid]);

  const handleSelectClass = (cls: ScheduledClass | "custom") => {
    if (typeof cls === "string") {
      setSelectedClassId("");
      setFilters((prev) => ({
        ...prev,
        center: "",
        yearOfGroup: "",
        subject: "",
        topic: "",
      }));
      setIsLocked(false);
      showSnackbar("Switched to Custom Request mode", "success");
    } else {
      // Specific class selection
      const newFilters = {
        center: cls.center_id,
        yearOfGroup: cls.yearLevel_id.toString(), // Ensure string for filter
        subject: cls.subject_id.toString(),
        topic: "",
      };
      setSelectedClassId(cls.csms_id);
      setFilters(newFilters);
      console.log(newFilters, "setFilters");
      setIsLocked(true);
      showSnackbar(
        `Selected class: ${cls.yearLevel} - ${cls.subject} on ${cls.date}`,
        "success"
      );
    }
    setIsSearchMode(false);
    dispatch(clearAiDriveSearch());
    setTableData([]);
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "15px" }}>
      {/* Welcome Section */}
      <WelcomeCard
        userName={username}
        title="Welcome to Everest Tutoring"
        description="Tutors can quickly download well-structured notes, worksheets, and exam-ready content to support their students. Everything you need to teach effectively—organized and ready to use."
      />
      <ClassContextBar
        classes={upcomingClasses}
        selectedClass={selectedClass}
        onSelectClass={handleSelectClass}
      />
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 3,
          backgroundColor: "#fff",
        }}
      >
        {/* {!selectedData ? (
          <Box
            sx={{
              border: "1px solid #e0e0e0",
              borderRadius: "8px",
              p: 3,
              backgroundColor: "#fff",
              textAlign: "center",
            }}
          >
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
              Please select class selection before selecting study material
            </Typography>
            <button
              onClick={() => navigate("/class_selection")}
              style={{
                padding: "10px 20px",
                borderRadius: "8px",
                backgroundColor: "#009DFF",
                color: "#fff",
                border: "none",
                cursor: "pointer",
                fontSize: "15px",
                fontWeight: "500",
              }}
            >
              Go to Class Selection
            </button>
          </Box>
        ) : (
          <>
            ORIGINAL SearchBar + Filters UI HERE */}
        <SearchBar
          // disabled={isLocked}
          subject_id={searchSubjectId}
          onSearchChange={(text) => {
            const isActive = text.trim().length > 0;
            setIsSearchMode(isActive);

            // 👇 Clear filters whenever search is used
            if (isActive) {
              setFilters((prev) => ({
                ...prev,
                yearOfGroup: "",
                subject: "",
                topic: "",
              }));
            }

            if (!isActive) {
              dispatch(clearAiDriveSearch());
              setTableData([]);
            }
          }}
        />

        <Box
          sx={{
            border: "1px solid #e0e0e0",
            borderRadius: "8px",
            p: 3,
            mt: 2,
            backgroundColor: "#fff",
          }}
        >
          <Typography variant="h6" sx={{ mb: 1 }}>
            Study Material
          </Typography>
          {!filters.topic && (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                gap: 1,
                mb: 3,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <ReportIcon sx={{ color: "#009FDD", fontSize: 22 }} />
              </Box>
              <Typography
                sx={{
                  textAlign: "center",
                  color: "#009FDD",
                  fontSize: "14px",
                  fontWeight: 400,
                }}
              >
                Please select a topic to view and add study materials
              </Typography>
            </Box>
          )}
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: "repeat(4, 1fr)",
              gap: 2,
            }}
          >
            <TextField
              select
              label="Center"
              name="center"
              value={filters.center}
              onChange={handleFilterChange}
              size="small"
              disabled={isLocked}
            >
              {CenterLoading ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : centerOptions.length === 0 ? (
                <MenuItem disabled>No data available</MenuItem>
              ) : (
                centerOptions.map((center: Option) => (
                  <MenuItem key={center.id} value={center.id}>
                    {center.label}
                  </MenuItem>
                ))
              )}
              {isLocked &&
                filters.center &&
                !centerOptions.find((c: any) => c.id === filters.center) && (
                  <MenuItem value={filters.center} style={{ display: "none" }}>
                    {(typeof selectedClass !== "string" &&
                      selectedClass?.center) ||
                      selectedData?.center_name ||
                      "Selected Center"}
                  </MenuItem>
                )}
            </TextField>
            <TextField
              select
              label="Year of Group"
              name="yearOfGroup"
              value={filters.yearOfGroup}
              onChange={handleFilterChange}
              size="small"
              disabled={isLocked || isSearchMode}
            >
              {yearGroupLoading ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : yearOptions.length === 0 ? (
                <MenuItem disabled>No data available</MenuItem>
              ) : (
                yearOptions.map((year: Option) => (
                  <MenuItem key={year.id} value={year.id}>
                    {year.label}
                  </MenuItem>
                ))
              )}
              {isLocked &&
                filters.yearOfGroup &&
                !yearOptions.find((y: any) => y.id === filters.yearOfGroup) && (
                  <MenuItem
                    value={filters.yearOfGroup}
                    style={{ display: "none" }}
                  >
                    {(typeof selectedClass !== "string" &&
                      selectedClass?.yearLevel) ||
                      selectedData?.yeargroup_name ||
                      "Selected Year"}
                  </MenuItem>
                )}
            </TextField>
            <TextField
              select
              label="Subject"
              name="subject"
              value={filters.subject}
              onChange={handleFilterChange}
              size="small"
              disabled={isLocked || isSearchMode}
            >
              {subjectLoading ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : subjectOptions.length === 0 ? (
                <MenuItem disabled>No data available</MenuItem>
              ) : (
                subjectOptions.map((sub: Option) => (
                  <MenuItem key={sub.id} value={sub.id}>
                    {sub.label}
                  </MenuItem>
                ))
              )}
              {isLocked &&
                filters.subject &&
                !subjectOptions.find((s: any) => s.id === filters.subject) && (
                  <MenuItem value={filters.subject} style={{ display: "none" }}>
                    {(typeof selectedClass !== "string" &&
                      selectedClass?.subject) ||
                      selectedData?.subject_name ||
                      "Selected subject"}
                  </MenuItem>
                )}
            </TextField>
            <TextField
              select
              label="Topic"
              name="topic"
              value={filters.topic}
              onChange={handleFilterChange}
              size="small"
              disabled={!filters.subject || isSearchMode}
              sx={{
                "& .MuiOutlinedInput-root": {
                  "& fieldset": {
                    borderColor: !filters.topic ? "#009DFF" : undefined,
                  },
                  "&:hover fieldset": {
                    borderColor: !filters.topic ? "#007ACC" : undefined,
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#009DFF",
                  },
                },
              }}
            >
              {driveFileLoading ? (
                <MenuItem disabled>Loading...</MenuItem>
              ) : topicOptions.length === 0 ? (
                <MenuItem disabled>No data available</MenuItem>
              ) : (
                topicOptions.map((top: Option) => (
                  <MenuItem key={top.id} value={top.id}>
                    {top.label}
                  </MenuItem>
                ))
              )}
            </TextField>
          </Box>
        </Box>
        {/* </> */}
        {/* )} */}
      </Box>
      {/* Table */}
      <Box
        sx={{
          border: "1px solid #e0e0e0",
          borderRadius: "8px",
          p: 3,
          backgroundColor: "#fff",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Box>
            <Typography variant="h6" sx={{ mb: 2 }}>
              Study Material Details
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mb: 3,
            }}
          >
            {/* Clear Filters */}
            <button
              onClick={clearAllFilters}
              style={{
                padding: "8px 16px",
                border: "1px solid #009DFF",
                backgroundColor: "white",
                color: "#009DFF",
                borderRadius: "20px",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Clear all
            </button>
            {/* Go to Cart */}
            <button
              onClick={() => navigate("/study_materials/cart")}
              style={{
                padding: "8px 16px",
                border: "1px solid #009DFF",
                backgroundColor: "white",
                color: "#009DFF",
                borderRadius: "20px",
                textTransform: "none",
                cursor: "pointer",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Go to cart
            </button>
          </Box>
        </Box>
        <Table<StudyMaterial>
          columns={columns}
          loading={searchDataLoading}
          data={tableData}
          onQuantityChange={handleQuantityChange}
          getPreviewId={(row) => row.id}
        />
      </Box>
      <Snackbar
        key={snackbar.key} // 👈 Important
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      >
        <Alert
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          severity={snackbar.severity}
          sx={{ width: "100%", minHeight: "50px" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};
export default StudyMaterials;
